import { render, staticRenderFns } from "./ChangePrestage.vue?vue&type=template&id=08dd5bf6&scoped=true&"
import script from "./ChangePrestage.vue?vue&type=script&lang=js&"
export * from "./ChangePrestage.vue?vue&type=script&lang=js&"
import style0 from "./ChangePrestage.vue?vue&type=style&index=0&id=08dd5bf6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08dd5bf6",
  null
  
)

export default component.exports